export default __webpack_public_path__ + "img/power-bi.1cb5a7.svg";